/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { Heading as BaseHeading, HeadingProps } from 'theme-ui';

export const Heading = styled(BaseHeading)<HeadingProps>`
  color: ${themeGet('colors.heading')};
  text-transform: uppercase;
  text-align: center;
`;
